export enum FolderEnum {
  General = 'מסמכים כלליים',
  BookKeeping = 'הנהלת חשבונות',
  Plans = 'תוכניות',
  Certificats = 'תעודות',
  SubProjects = 'הסכמים',
  Orders = 'הזמנות',
  Temporary = 'קבצים לפיזור',
  CheckList = 'תמונות מהשטח'
}
